import FUENTES_FINANCIERAS from '@/graphql/querys/administracion/catalogos/fuentesfinancieras/fuentesFinancieras.gql';
import AGREGAR_FUENTE_FINANCIERA from '@/graphql/mutations/administracion/catalogos/fuentesfinancieras/agregarFuenteFinanciera.gql';
import ACTUALIZAR_FUENTE_FINANCIERA from '@/graphql/mutations/administracion/catalogos/fuentesfinancieras/actualizarFuenteFinanciera.gql';
import REMOVER_FUENTE_FINANCIERA from '@/graphql/mutations/administracion/catalogos/fuentesfinancieras/removerFuenteFinanciera.gql';

export default {
  methods: {
    async mixAgregarFuenteFinanciera() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_FUENTE_FINANCIERA,
        variables: {
          fuenteFinanciera: this.fuenteFinanciera,
        },
        update: (store, { data: { agregarFuenteFinanciera } }) => {
          const data = store.readQuery({ query: FUENTES_FINANCIERAS });
          data.fuentesFinancieras.push(agregarFuenteFinanciera);
          store.writeQuery({ query: FUENTES_FINANCIERAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarFuenteFinanciera() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_FUENTE_FINANCIERA,
        variables: {
          id: this.fuenteFinancieraEditar.id,
          fuenteFinanciera: this.fuenteFinanciera,
        },
        update: (store, { data: { actualizarFuenteFinanciera } }) => {
          // console.log(actualizarProgramaInversion);
          const data = store.readQuery({ query: FUENTES_FINANCIERAS });
          const { fuentesFinancieras } = data;
          const index = fuentesFinancieras
            .findIndex((fuenteFinanciera) => fuenteFinanciera.id
            === actualizarFuenteFinanciera.id);
          if (index !== -1) {
            fuentesFinancieras.splice(index, 1, actualizarFuenteFinanciera);
          }
          store.writeQuery({ query: FUENTES_FINANCIERAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEliminarFuenteFinanciera() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_FUENTE_FINANCIERA,
        variables: {
          id: this.fuenteFinancieraEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: FUENTES_FINANCIERAS });
          const { fuentesFinancieras } = data;
          const index = fuentesFinancieras
            .findIndex((fuenteFinanciera) => fuenteFinanciera.id
            === this.fuenteFinancieraEliminar.id);
          if (index !== -1) {
            fuentesFinancieras.splice(index, 1);
          }
          store.writeQuery({ query: FUENTES_FINANCIERAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
